function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import find from 'lodash/find';
import get from 'lodash/get';
import useStyles from 'isomorphic-style-loader/useStyles';
import { formatDate } from 'helpers/datetime';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import messages from '../../messages';
import styles from './TableSchema.pcss';
const useTableSchema = (mode, visits, onShowNotes)=>{
    useStyles(styles);
    const renderHcp = (visit)=>{
        const { phisetVisitId } = visit;
        const visitMetadata = find(visits, {
            phisetVisitId
        });
        const createdBy = get(visitMetadata, 'metadata.createdBy');
        if (!createdBy) return null;
        const { firstName, lastName, avatar, clinicName } = createdBy;
        if (firstName && lastName) {
            return /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center",
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        avatarImg: avatar,
                        name: [
                            firstName,
                            lastName
                        ],
                        className: `${styles.avatar} mr-3`,
                        imgClassName: styles.avatar__img,
                        initialsClassName: styles.avatar__initials
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.avatar__name,
                        children: [
                            firstName,
                            " ",
                            lastName
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsx("h2", {
            className: "brand__h2",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.hcpFromClinic), {
                values: {
                    clinicName
                }
            }))
        });
    };
    const renderVisitDate = (visit)=>{
        const { phisetVisitId } = visit;
        const visitMetadata = find(visits, {
            phisetVisitId
        });
        const visitDate = get(visitMetadata, 'metadata.visitDate');
        if (!visitDate) return null;
        return formatDate(visitDate);
    };
    const renderClinic = (visit)=>{
        const { phisetVisitId } = visit;
        const visitMetadata = find(visits, {
            phisetVisitId
        });
        return /*#__PURE__*/ _jsx("div", {
            className: styles.table__clinicCell,
            children: get(visitMetadata, 'metadata.createdBy.clinicName', '')
        });
    };
    const renderVisitActions = (visit)=>{
        const associatedNotesBatches = get(visit, 'associatedDataIndexKeys.notes', []);
        const replies = get(visit, 'replies', 0);
        if (!associatedNotesBatches.length) {
            return /*#__PURE__*/ _jsx("div", {
                className: styles.table__notesCellEmpty,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.noNotesToShow))
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            className: styles.table__showNotes,
            children: /*#__PURE__*/ _jsxs(Button, {
                styleModifier: "primary",
                className: "btn--md w-100",
                isDisabled: !associatedNotesBatches.length,
                onClick: ()=>onShowNotes(visit),
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.showNotes)),
                    replies ? ` (${replies})` : null
                ]
            })
        });
    };
    return [
        {
            key: 'hcp',
            labelMessage: messages.labels.hcp,
            renderer: (visit)=>renderHcp(visit)
        },
        {
            key: 'visitDate',
            labelMessage: messages.labels.date,
            renderer: (visit)=>renderVisitDate(visit)
        },
        ...mode === 'PWD' ? [
            {
                key: 'clinicName',
                labelMessage: messages.labels.clinic,
                renderer: (visit)=>renderClinic(visit)
            }
        ] : [],
        {
            key: 'actions',
            labelMessage: messages.labels.visitNotes,
            renderer: (visit)=>renderVisitActions(visit)
        }
    ];
};
export default useTableSchema;
